import React from "react";
import classnames from "classnames";
import { withStyles } from "material-ui/styles";
import {
  Button,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox
} from "material-ui";
import teal from "material-ui/colors/teal";
import indigo from "material-ui/colors/indigo";
import CTable, {
  CTableHead,
  CTableBody,
  CTableRow,
  CHeadCell,
  CBodyCell
} from "uis/CTable";
import CTextField from "uis/CTextField";
import CInput from "uis/CInput";
import CTooltips from "uis/CTooltips";

import CustomerModalContainer from "containers/CustomerList/CustomerModalContainer";
import Pagination from "components/Pagination";
import BrowserCheck from "components/BrowserCheck";

const styles = () => ({
  container: {
    padding: 20,
    margin: "20px auto",
    width: 1100
  },
  header: {
    display: "flex"
  },
  title: {
    margin: 0,
    flex: 1
  },
  main: {
    padding: 20
  },
  searchArea: {
    display: "flex",
    float: "left",
    marginBottom: 5
  },
  searchCustomerKey: {
    marginRight: 20,
    width: 97
  },
  searchCustomerName: {
    marginRight: 20,
    width: 300
  },
  searchIndustry: {
    marginRight: 20,
    minWidth: 300
  },
  searchMemo: {
    marginRight: 20,
    width: 418
  },

  searchEnterpriseScale: {
    marginRight: 20,
    minWidth: 150
  },

  searchCheckbox: {
    marginTop: 10
  },
  searchBtn: {
    float: "right"
  },
  clear: {
    clear: "both"
  },
  center: {
    textAlign: "center"
  },
  counter: {
    margin: "0 10px"
  },
  pagination: {
    float: "left"
  },
  totalCount: {
    float: "right"
  },
  footerPagination: {
    margin: "0 10px"
  },
  tableRow: {
    height: 60
  },
  headCellCustomerKey: {
    width: 80
  },
  headCellLogo: {
    width: 80
  },
  headCellIndustry: {
    width: 270
  },
  headCellExistOpenSurvey: {
    padding: 5,
    width: 110,
    lineHeight: "1.2rem"
  },
  headCellProgress: {
    width: 110
  },
  headerCellLink: {
    width: 60
  },
  cTooltips: {
    position: "relative"
  },
  tooltip: {
    width: 290
  },
  bodyCell: {
    padding: "5px 10px"
  },
  bodyCellLogo: {
    padding: 10
  },
  bodyCellProgress: {
    whiteSpace: "nowrap"
  },
  bodyCellLink: {
    padding: 0
  },
  surveyLabel: {
    width: 70,
    borderRadius: 15,
    margin: "auto",
    padding: 2,
    color: "white",
    fontSize: ".9rem"
  },
  openLabelColor: {
    backgroundColor: teal[500]
  },
  closeLabelColor: {
    backgroundColor: indigo[900]
  },
  logo: {
    maxWidth: 50,
    maxHeight: 50,
    verticalAlign: "middle",
    borderRadius: 2
  }
});

class CustomerList extends React.Component {
  componentWillMount() {
    this.props.fetchCustomerList(
      this.props.customerList.search,
      this.props.customerList.page
    );
  }

  industryLargeSelect() {
    const { industries } = this.props.customerList;
    return [{ id: 0, name: "全て" }, ...industries.large];
  }

  industryMiddleSelect(parentId) {
    const { industries } = this.props.customerList;
    const list = industries.middle.filter(v => v.parentId === parentId);
    return [{ id: 0, name: "全て" }, ...list];
  }


  enterpriseScaleSelect() {
    return [{ id: 0, name: "全て" }, { id: 1, name: "大企業" }, { id: 2, name: "中小企業" }];
  }


  render() {
    const { classes, customerList } = this.props;
    const { search, customers, page, totalCount, perPage } = customerList;
    const {
      fetchCustomerList,
      openCustomerModal,
      changeSearchForm,
      historyPush,
      changePage
    } = this.props;

    return (
      <Paper className={classes.container}>
        <CustomerModalContainer
          fetchCustomerList={() => fetchCustomerList(search, 1)}
        />

        <div className={classes.header}>
          <h2 className={classes.title}>顧客一覧</h2>

          <Button raised onClick={openCustomerModal}>
            新規登録
          </Button>
          <div className={classes.clear} />
        </div>

        <BrowserCheck />

        <div className={classes.main}>
          <div>
            <div className={classes.searchArea}>
              <CTextField
                id="search-customer-key"
                label="顧客ID"
                value={search.customerKey}
                className={classes.searchCustomerKey}
                onChange={e => changeSearchForm("customerKey", e.target.value)}
              />

              <CTextField
                id="search-customer-name"
                label="顧客名"
                value={search.customerName}
                className={classes.searchCustomerName}
                onChange={e => changeSearchForm("customerName", e.target.value)}
              />

              <FormControl className={classes.searchIndustry}>
                <InputLabel shrink htmlFor="search-industry-id">
                  産業分類(大分類)
                </InputLabel>
                <Select
                  value={search.industryParentId}
                  onChange={e =>
                    changeSearchForm("industryParentId", e.target.value)
                  }
                  input={
                    <CInput name="search-industry-id" id="search-industry-id" />
                  }
                >
                  {this.industryLargeSelect().map(industry => (
                    <MenuItem key={industry.id} value={industry.id}>
                      {industry.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl className={classes.searchIndustry}>
                <InputLabel shrink htmlFor="search-industry-id">
                  産業分類(中分類)
                </InputLabel>
                <Select
                  value={search.industryId}
                  onChange={e => changeSearchForm("industryId", e.target.value)}
                  input={
                    <CInput name="search-industry-id" id="search-industry-id" />
                  }
                >
                  {this.industryMiddleSelect(search.industryParentId).map(
                    industry => (
                      <MenuItem key={industry.id} value={industry.id}>
                        {industry.name}
                      </MenuItem>
                    )
                  )}
                </Select>
              </FormControl>
            </div>

            <div className={classes.searchArea}>
              <CTextField
                id="search-memo"
                label="メモ"
                value={search.memo}
                className={classes.searchMemo}
                onChange={e => changeSearchForm("memo", e.target.value)}
              />


              <FormControl className={classes.searchEnterpriseScale}>
                <InputLabel shrink htmlFor="search-enterprise-scale">
                  企業規模
                </InputLabel>
                <Select
                  value={search.enterpriseScale}
                  onChange={e =>
                    changeSearchForm("enterpriseScale", e.target.value)
                  }
                  input={
                    <CInput name="search-enterprise-scale" id="search-enterprise-scale" />
                  }
                >
                  {this.enterpriseScaleSelect().map(enterprise => (
                    <MenuItem key={enterprise.id} value={enterprise.id}>
                      {enterprise.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>


              <FormControlLabel
                control={
                  <Checkbox
                    checked={search.showOnlyOpeningSurveyCustomer}
                    onChange={e =>
                      changeSearchForm(
                        "showOnlyOpeningSurveyCustomer",
                        e.target.checked
                      )
                    }
                  />
                }
                label="アンケートを公開中の顧客のみ表示する"
                className={classes.searchCheckbox}
              />
            </div>

            <Button
              raised
              className={classes.searchBtn}
              onClick={() => fetchCustomerList(search, 1)}
            >
              検索
            </Button>

            <div className={classes.clear} />
          </div>

          <div className={classes.counter}>
            <Pagination
              className={classes.pagination}
              totalCount={totalCount}
              perPage={perPage}
              page={page}
              handleClick={_page => {
                changePage(_page);
                fetchCustomerList(search, _page);
              }}
            />

            <div className={classes.totalCount}>{totalCount} 件</div>
          </div>

          <CTable>
            <CTableHead>
              <CTableRow>
                <CHeadCell className={classes.headCellCustomerKey}>
                  顧客ID
                </CHeadCell>
                <CHeadCell>顧客名</CHeadCell>
                <CHeadCell className={classes.headCellIndustry}>
                  産業分類
                </CHeadCell>
                <CHeadCell className={classes.headCellExistOpenSurvey}>
                  公開中の<br />アンケート
                </CHeadCell>
                <CHeadCell className={classes.headCellProgress}>
                  <CTooltips
                    text="進捗"
                    title={
                      "公開中のアンケートがある場合に、\n" +
                      "その中で最も終了日が近いアンケートの\n" +
                      "回答進捗状況を表示します。"
                    }
                    placement="bottom"
                    className={classes.cTooltips}
                    classes={{ tooltip: classes.tooltip }}
                  />
                </CHeadCell>
                <CHeadCell className={classes.headerCellLink}>{}</CHeadCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {customers.map(customer => (
                <CTableRow
                  key={customer.customerKey}
                  className={classes.tableRow}
                >
                  <CBodyCell center className={classes.bodyCell}>
                    {customer.customerKey}
                  </CBodyCell>
                  <CBodyCell>{customer.customerName}</CBodyCell>
                  <CBodyCell>
                    <div>{`${customer.industryParent ? customer.industryParent.get("name") : ''} - ${customer.industry ? customer.industry.get("name") : ''}`}</div>
                  </CBodyCell>
                  <CBodyCell center>
                    <div
                      className={classnames(
                        classes.surveyLabel,
                        customer.isOpeningSurveyExist
                          ? classes.openLabelColor
                          : classes.closeLabelColor
                      )}
                    >
                      {customer.isOpeningSurveyExist ? "あり" : "なし"}
                    </div>
                  </CBodyCell>

                  {customer.latestSurvey ? (
                    <CBodyCell center className={classes.bodyCellProgress}>
                      <div>{customer.latestSurvey.progressRatio()} %</div>
                      <div>{customer.latestSurvey.progressFmt()}</div>
                    </CBodyCell>
                  ) : (
                    <CBodyCell center>-</CBodyCell>
                  )}

                  <CBodyCell center className={classes.bodyCellLink}>
                    <Button onClick={historyPush(`/customer/${customer.id}`)}>
                      詳細
                    </Button>
                  </CBodyCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>

          <Pagination
            className={classes.footerPagination}
            totalCount={totalCount}
            perPage={perPage}
            page={page}
            handleClick={_page => {
              changePage(_page);
              fetchCustomerList(search, _page);
            }}
          />
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(CustomerList);



// WEBPACK FOOTER //
// ./src/components/CustomerList.jsx